import Translation from './index'
import ITranslationKeys from './ITranslationKeys'

export default class SpanishTranslation extends Translation implements ITranslationKeys {
  public 'error.unexpected' = 'Error inesperado.'
  public 'error.404' = 'No hemos podido encontrar la página solicitada. Te invitamos a visitar nuestra página de inicio.'
  public 'error.select.min.an.option' = 'Selecciona al menos una opción'

  public 'user.edit.profile' = 'Editar perfil'
  public 'user.close.account' = 'Cerrar cuenta'
  public 'user.manage.billing' = 'Pagos y subscripciones'

  public 'profile.documents.title' = 'Mis documentos'
  public 'profile.languages.title' = 'Mis idiomas'
  public 'profile.languages.add' = 'Idioma'
  public 'profile.languages.empty' = 'Aún no has añadido ningún idioma.'
  public 'profile.languages.level.label' = 'Nivel'

  public 'profile.cv.latest' = 'CV más reciente'
  public 'profile.cv.upgrade.to.analyze' = 'Únete a Bloom Pro para analizar tu CV'

  public 'profile.academicTranscript.title' = 'Expediente académico'
  public 'profile.academicTranscript.latest' = 'Último expediente académico'

  public 'checkout.already.bought' = 'Hemos detectado que ya tienes una subscripción activa'
  public 'checkout.already.bought.explanation' = 'Si quieres cambiarla, puedes hacerlo en la sección de "Pagos y subscripciones" de tu perfil.'
  public 'checkout.success' = 'Gracias, el pago se ha realizado correctamente.'

  public 'auth.signup.notAllowed' = 'Lo sentimos, parece que este email no tiene acceso a Bloom. Si crees que es un error, ponte en contacto con hola@zriveapp.com'
  public 'auth.access.not.active' = 'Tu acceso ha caducado.'
  public 'auth.access.free.not.active' = 'Lo sentimos pero el periodo de colaboración con tu universidad ha expirado.'
  public 'auth.access.wordpress.not.active' = 'Lo sentimos, parece que tu cuenta de Zrive no está activa. Si crees que es un error, ponte en contacto con hola@zriveapp.com'
  public 'auth.login.or.signup' = 'Inicia sesión o crea tu cuenta'
  public 'auth.login.with.another.account' = 'Iniciar sesión con otra cuenta'
  public 'auth.account.delete.success' = 'Tu cuenta ha sido eliminada'
  public 'auth.account.delete.confirm' = '¿Estás seguro de que quieres eliminar tu cuenta? Esta acción no se puede deshacer.'
  public 'auth.account.delete.confirm.yes' = 'Sí, quiero cerrar mi cuenta'
  public 'auth.account.delete.confirm.no' = 'No, quiero mantener mi cuenta'
  public 'auth.email.mismatch' = 'Los emails no coinciden. Por favor, asegúrate de que ambos emails son iguales.'
  public 'auth.email.again' = 'Introduce tu email nuevamente'

  public 'auth.login.username' = 'Email'
  public 'auth.login.password' = 'Contraseña'
  public 'auth.login.signIn' = 'Inicia sesión'
  public 'auth.login.signUp' = 'Crear cuenta'
  public 'auth.login.forgotPassword' = '¿Olvidaste tu contraseña?'
  public 'auth.login.resetPassword' = 'Resetéala aquí'
  public 'auth.login.needVerification' = '¿Ya tienes una cuenta pero aún no has verificado tu email?'
  public 'auth.login.verifyEmail' = 'Verifícalo aquí'

  public 'auth.signup.signUp' = 'Registrarme'
  public 'auth.signup.passwordMismatch' = 'Las contraseñas no coinciden'
  public 'auth.signup.confirmPassword' = 'Confirmar contraseña'
  public 'auth.signup.success' = '¡Cuenta creada correctamente! A continuación recibirás un email para activar tu cuenta.'

  public 'auth.resetPassword.code' = 'Código de verificación'
  public 'auth.resetPassword.confirm' = 'Confirmar'
  public 'auth.resetPassword.submit' = 'Enviar'
  public 'auth.resetPassword.message' = 'Por favor, revisa tu email para obtener el código de verificación.'
  public 'auth.resetPassword.description' = 'Introduce tu email para resetear tu contraseña.'
  public 'auth.confirmResetPassword.description' = 'Confirma tu nueva contraseña.'

  public 'auth.verify.username' = 'Introduce tu email'
  public 'auth.verify.code' = 'Código de verificación'
  public 'auth.verify.enterCode' = 'Introduce el código de verificación'
  public 'auth.verify.verify' = 'Verificar'
  public 'auth.verify.resendCode' = 'Reenviar código'
  public 'auth.verify.codeSent' = 'Código enviado. Deberías recibir un email con el código de verificación en unos segundos.'
  public 'auth.verify.codeSent.auto' = 'Te acabamos de enviar un email con el código de verificación.'
  public 'auth.verify.codeVerified' = '¡Email verificado correctamente!'
  public 'menu.home' = 'Inicio'
  public 'menu.content' = 'Contenido'
  public 'menu.logout' = 'Desconectar'
  public 'menu.cookiePolicy' = 'Política de cookies'
  public 'menu.privacyPolicy' = 'Política de privacidad'
  public 'menu.hello' = 'Hola'
  public 'menu.profile' = 'Perfil'
  public 'menu.my.profile' = 'Mi perfil'
  public 'menu.bookmarks' = 'Favoritos'
  public 'menu.internalOffersFaqs' = 'Ofertas BLOOM - FAQs'

  public 'onboarding.title' = '¡Únete a BLOOM!'
  public 'onboarding.description' = 'Antes de que empieces a explorar todo el contenido sobre carreras profesionales que hemos preparado para ti, queremos conocerte mejor para poder ofrecerte una experiencia personalizada.'
  public 'onboarding.personal.title' = 'Datos personales'
  public 'onboarding.personal.update.description' = '¿Quieres actualizar tus datos personales con los que te registraste en BLOOM?'
  public 'onboarding.qualificationLevel' = '¿Cuál es tu nivel de estudios?'
  public 'onboarding.studies.title' = 'Estudios'
  public 'onboarding.studies.description' = 'En primer lugar, queremos hacerte algunas preguntas acerca de tus estudios universitarios.'
  public 'onboarding.studies.studying.bachelor' = 'Estudiando grado'
  public 'onboarding.studies.studying.master' = 'Estudiando máster'
  public 'onboarding.studies.graduated' = 'Estudios finalizados'
  public 'onboarding.studies.academicLevel' = '¿Cuál es tu situación actual?'
  public 'onboarding.working.question' = '¿Cuál es tu situación profesional actual?'
  public 'onboarding.working.employed' = 'Trabajando'
  public 'onboarding.working.no' = 'En búsqueda de empleo'
  public 'onboarding.preferences.title' = 'Intereses'
  public 'onboarding.preferences.description' = 'Ahora nos gustaría saber cuáles son tus planes profesionales y qué sectores son los que más te interesan.'
  public 'onboarding.preferences.knowing.profOps' = '¿Cuánto conoces el rango de salidas profesionales a las que podrías acceder?'
  public 'onboarding.preferences.knowing.goals' = '¿Cómo de claro tienes qué carrera profesional quieres perseguir?'
  public 'onboarding.preferences.which.fav.topics' = 'De las categorías que cubrimos en BLOOM, ¿cuáles son las que más te interesan?'
  public 'onboarding.preferences.which.goals' = '¿Con cuál de los siguientes aspectos consideras que BLOOM puede serte de mayor ayuda?'
  public 'onboarding.preferences.goals.explore.jobs' = 'Explorar distintas opciones laborales'
  public 'onboarding.preferences.goals.get.jobs' = 'Acceder a ofertas de trabajo'
  public 'onboarding.preferences.goals.prepare.interviews' = 'Prepararme para superar los procesos de selección'
  public 'onboarding.news.title' = 'Comunicaciones'
  public 'onboarding.news.description' = '¿Quieres que te informemos de lo que ocurre en BLOOM?'
  public 'onboarding.news.whatsapp.title' = 'Recibir avisos por Whatsapp'
  public 'onboarding.news.whatsapp.description' = 'Te informaremos de todas las novedades de BLOOM a través de email, pero si quieres que te enviemos notificaciones también por Whatsapp activa está opción y déjanos tu número.'
  public 'onboarding.news.jobs.title' = 'Quiero recibir un email cuando se publiquen nuevas ofertas de empleo'
  public 'onboarding.news.jobs.sectors' = 'Dinos qué salidas profesionales te interesan y te avisaremos cuando haya nuevas ofertas de empleo relacionadas.'
  public 'onboarding.update' = 'Actualizar mi perfil'
  public 'onboarding.linkedin' = 'Validar perfil'
  public 'onboarding.linkedin.description' = 'Para garantizar que BLOOM esté libre de bots y perfiles falsos, necesitamos verificar tu identidad a través de tu cuenta de LinkedIn.\nEsta comprobación solo será necesaria una vez.'
  public 'onboarding.linkedin.connect' = 'Validar mi perfil'
  public 'onboarding.linkedin.connected' = '¡Linkedin conectado!'

  public 'videos.last' = 'Últimos vídeos'
  public 'videos.recommended' = 'Recomendados para ti'
  public 'videos.history' = 'Vídeos que he visto'
  public 'videos.next.playing.in' = 'Siguiente video en'

  public 'documents.last' = 'Últimos documentos'
  public 'documents.read' = 'de lectura'

  public 'common.add' = 'Añadir'
  public 'common.yes' = 'Sí'
  public 'common.remove' = 'Eliminar'
  public 'common.no' = 'No'
  public 'common.all' = 'Todos'
  public 'common.seeAll' = 'Ver todos'
  public 'common.seeMore' = 'Ver más'
  public 'common.seeDetails' = 'Ver detalles'
  public 'common.seeAll_fem' = 'Ver todas'
  public 'common.loadingUser' = 'Cargando usuario'
  public 'common.errorFetchingUser' = 'Error cargando usuario'
  public 'common.save' = 'Guardar'
  public 'common.name' = 'Nombre'
  public 'common.lastName' = 'Apellido'
  public 'common.back' = 'Volver'
  public 'common.backTo' = 'Volver a'
  public 'common.type' = 'Tipo'
  public 'common.noResults' = 'No hay resultados'
  public 'common.sortBy' = 'Ordenar por'
  public 'common.sortBy.alphabetically' = 'Alfabéticamente'
  public 'common.sortBy.recommended' = 'Recomendado'
  public 'common.sortBy.latest' = 'Más recientes'
  public 'common.sortBy.title' = 'Título'
  public 'common.moreInfo' = 'Más información'
  public 'common.keepUpToDate' = 'Mantente al día'
  public 'common.continue' = 'Continuar'
  public 'common.bachelor' = 'Grado'
  public 'common.bachelor.and.master' = 'Grado y Máster'
  public 'common.bachelor.name' = 'Nombre del grado'
  public 'common.bachelor.year.start' = '¿En qué año comenzaste el grado?'
  public 'common.industry' = 'Industria'
  public 'common.industry.sector' = '¿En qué sector estás trabajando?'
  public 'common.bachelor.university' = 'Universidad donde estudiaste el grado'
  public 'common.master.university' = 'Universidad donde estudias el máster'
  public 'common.master.name' = '¿Qué máster estás estudiando?'
  public 'common.master.year.end' = '¿En qué año terminas el máster?'
  public 'common.nothing' = 'Nada'
  public 'common.nothing.clear' = 'Nada claro'
  public 'common.all.clear' = 'Totalmente claro'
  public 'common.lots' = 'Mucho'
  public 'common.phone' = 'Teléfono'
  public 'common.start.now' = 'Comenzar ahora'
  public 'common.filter' = 'Filtrar'
  public 'common.acceptPrivacyPolicy' = 'He leido y acepto la'
  public 'common.privacyPolicy' = 'política de privacidad'
  public 'common.letsStart' = '¡Empecemos!'
  public 'common.and' = 'y'
  public 'common.daysAgo_1' = 'Hace {{days}} día'
  public 'common.daysAgo_0' = 'Hoy'
  public 'common.daysAgo' = 'Hace {{days}} días'
  public 'common.description' = 'Descripción'
  public 'common.min.requirements' = 'Requisitos mínimos'
  public 'common.cities' = 'Ciudades'
  public 'common.copyLink' = 'Copiar link'
  public 'common.clipboardCopied' = 'Link copiado al portapapeles'
  public 'common.share' = 'Compartir'
  public 'common.here' = 'aquí'
  public 'common.close' = 'Cerrar'
  public 'common.see' = 'Ver'
  public 'common.characters' = 'caracteres'
  public 'common.file.select' = 'Seleccionar archivo'
  public 'common.file.change' = 'Cambiar archivo'
  public 'common.file.exceeds.size' = 'El tamaño del archivo excede el límite de {{size}}'
  public 'common.file.noSelected' = 'Ningún archivo seleccionado'
  public 'common.go.home' = 'Volver al inicio'
  public 'common.send' = 'Enviar'
  public 'common.cancel' = 'Cancelar'

  public 'content.category' = 'Categoría'
  public 'content.categories.all' = 'Todas las categorías'
  public 'content.sector' = 'Sector'
  public 'content.videos' = 'Videos'
  public 'content.videos.continueWatching' = 'Seguir viendo'
  public 'content.videoTypes' = 'Tipo de sesión'
  public 'content.documents' = 'Documentos'
  public 'content.documents.seeFull' = 'Ver documento completo'
  public 'content.documentTypes' = 'Tipo'
  public 'content.result' = 'resultado'
  public 'content.result_plural' = 'resultados'
  public 'content.difficultyLevel' = 'Nivel'
  public 'content.searchByKeyword' = 'Filtrar por palabra clave'
  public 'content.moreAuthors' = 'ponente más'
  public 'content.searchDesktop' = '¿Qué necesitas? Busca videos, documentos, compañías, eventos...'
  public 'content.searchMobile' = 'Busca videos, documentos, compañías, eventos...'
  public 'content.remove.filters' = 'Eliminar filtros'
  public 'content.see.results' = 'Ver resultados'
  public 'content.bookmarked.add' = 'Agregar a favoritos'
  public 'content.bookmarked.remove' = 'Eliminar de favoritos'
  public 'content.bookmarked.success' = 'Guardado en favoritos'
  public 'content.unbookmarked.success' = 'Eliminado de favoritos'
  public 'content.related' = 'Recursos relacionados'

  public 'notifications.title' = 'Notificaciones'
  public 'notifications.noNotifications' = 'No hay notificaciones por el momento'

  public 'events.title' = 'Eventos'
  public 'events.next' = 'Próximos eventos'
  public 'events.seeAll' = 'Ver todos'
  public 'events.noEvents' = 'No hay eventos programados en este momento!'
  public 'events.rsvp.attend' = 'Me interesa'
  public 'events.rsvp.attending' = 'Asistiré'
  public 'events.add.to.calendar' = 'Añadir en mi calendario'

  public 'advisor.historic.title' = 'Consultas históricas'
  public 'advisor.whatDoYouNeed' = 'Cuéntame qué necesitas...'
  public 'advisor.question1' = '¿Qué tengo que tener en cuenta al hacer mi CV?'
  public 'advisor.question2' = '¿Cuáles son mis principales salidas profesionales en Derecho?'
  public 'advisor.question3' = '¿Cuál es el salario de un consultor estratégico?'
  public 'advisor.sources' = 'Fuentes'
  public 'advisor.notAvailable' = 'ZriveGPT no está disponible en este momento'
  public 'advisor.newConversation' = 'Nuevo chat'


  public 'companies.title' = 'Empresas'
  public 'companies.description' = 'Explora las mejores empresas de los sectores que te interesan.'
  public 'companies.culture.title' = '¿Qué nos hace diferentes?'
  public 'companies.work.title' = 'Trabaja en {{companyName}}'
  public 'companies.work.officesIn' = 'Oficinas en {{cities}}'
  public 'companies.work.officesIn_one' = 'Oficina en {{cities}}'
  public 'companies.work.officesIn_other' = 'Oficinas en {{cities}}'
  public 'companies.contact.title' = '¿Tienes dudas?'
  public 'companies.contact.followUs' = 'Sigue a {{companyName}} en sus redes sociales:'
  public 'companies.applicants.profile' = 'Perfil de los candidatos'
  public 'companies.position.details' = 'Detalles de la posición'
  public 'companies.process.selection' = 'Proceso de selección'
  public 'companies.interview.get' = 'Accede al proceso'
  public 'companies.interview.pass' = 'Supera las entrevistas'
  public 'companies.interview.take.account' = 'Recomendaciones para aplicar'
  public 'companies.interview.doc.types' = '¿Qué documentos necesitas?'
  public 'companies.interview.cv.valoration' = '¿Qué valoramos en tu CV?'
  public 'companies.interview.process.works' = 'Cómo funciona el proceso de selección'
  public 'companies.interview.resources.links' = 'Prepárate con estos recursos'
  public 'companies.interview.skills.tested' = '¿Qué evaluamos en las entrevistas?'

  public 'cv' = 'Curriculum Vitae'
  public 'cv.uploaded' = 'Nuevo CV subido'
  public 'cv.analysis.new' = 'Analizar nuevo CV'
  public 'cv.analysis.results' = 'Análisis del CV'
  public 'cv.analysis.results.for.offer' = 'Compatibilidad de tu CV'
  public 'cv.analysis.resources' = 'Recursos'
  public 'cv.analysis.resources.video' = 'Puedes ver este <1>video</1> en el que explicamos todas las claves de un buen CV.'
  public 'cv.analysis.resources.document' = 'En este <1>documento</1> podrás encontrar las principales partes en las que se fijan las empresas.'
  public 'cv.analysis.resources.templates' = 'Te recomendamos que utilices este <1>template</1> que ha sido validado por Zrive.'
  public 'cv.quality.excellent' = 'Excelente'
  public 'cv.quality.good' = 'Bueno'
  public 'cv.quality.needs.improvement' = 'Necesita Mejoras'
  public 'cv.points.improvement' = 'Puntos de Mejora'
  public 'cv.points.offer.requirements' = 'Requisitos no presentes en el CV'
  public 'cv.no.improvement.points' = 'No se identificaron puntos de mejora.'
  public 'cv.upload.title' = 'Añade tu CV'
  public 'cv.upload.description' = 'Solo se admiten archivos PDF, ya que es el que se debería enviar siempre a las empresas.'
  public 'cv.upload.select' = 'Añadir CV'
  public 'cv.upload.change' = 'Cambiar Archivo'
  public 'academic.transcript.title' = 'Expediente Académico'
  public 'academic.transcript.upload.select' = 'Añadir Expediente Académico'
  public 'academic.transcript.upload.change' = 'Cambiar Archivo'
  public 'jobs.apply.coverLetter.title' = 'Carta de presentación'
  public 'jobs.apply.coverLetter.upload.select' = 'Añadir carta de presentación'
  public 'jobs.apply.coverLetter.upload.change' = 'Cambiar archivo'
  public 'jobs.apply.languages.title' = 'Niveles de idioma'
  public 'jobs.apply.languages.selectLevel' = 'Selecciona tu nivel'
  public 'academic.transcript.latest.used' = 'Se utilizará tu último expediente académico.'
  public 'academic.transcript.uploaded' = 'Nuevo expediente académico subido'
  public 'academic.transcript.upload.processing' = 'Subiendo...'
  public 'cv.upload.analyzing' = 'Analizando...'
  public 'cv.upload.analyze' = 'Analizar CV'
  public 'cv.upload.loadingMessages.processing' = 'Estamos procesando tu CV'
  public 'cv.upload.loadingMessages.checkingFormat' = 'Comprobando que el formato es correcto'
  public 'cv.upload.loadingMessages.analyzingStructure' = 'Analizando la estructura del contenido'
  public 'cv.upload.loadingMessages.checkingConsistency' = 'Comprobando la consistencia y estilo'
  public 'cv.upload.loadingMessages.takingTime' = 'Esto va a llevar algo de tiempo'
  public 'cv.upload.loadingMessages.stillWorking' = 'Seguimos trabajando en ello'
  public 'cv.upload.loadingMessages.almostThere' = 'Ya casi estamos'
  public 'cv.upload.loadingMessages.finalTouches' = 'Ultimando los detalles'
  public 'cv.page.title' = 'CV Roaster'
  public 'cv.page.description' = 'Mejora tu CV con nuestra IA, que lo analiza y evalúa basándose en el conocimiento de Zrive sobre cómo crear buenos CVs para perfiles junior.'
  public 'ai.disclaimer' = 'Esta herramienta está diseñada para servir como orientación, ya que,  aunque ha sido rigurosamente probada, utiliza modelos de IA que, por su  naturaleza, pueden generar inexactitudes.'
  public 'cv.error.selectFile' = 'Por favor, selecciona un archivo CV para subir'
  public 'cv.error.analysisFailed' = 'Error al analizar el CV'
  public 'cv.save.new.version' = 'Guardar versión de CV'

  public 'ai.user.feedback.saved' = '¡Gracias por tu feedback!'
  public 'ai.user.positive.feedback.placeholder' = 'Cuéntanos qué funcionó bien para ti'
  public 'ai.user.negative.feedback.placeholder' = 'Describe qué no funcionó como esperabas'
  public 'interviewer.ai.title' = 'Elige que entrevista quieres practicar hoy'
  public 'interviewer.ai.progress' = 'En progreso'
  public 'interviewer.ai.start' = 'Empezar Entrevista'
  public 'interviewer.ai.start.new' = 'Empezar Nueva Entrevista'
  public 'interviewer.ai.continue' = 'Continuar Entrevista'
  public 'interviewer.ai.new' = 'Nueva Entrevista'
  public 'interviewer.ai.completed' = '¡Entrevista Completada!'
  public 'interviewer.ai.passed' = 'Aprobado'
  public 'interviewer.ai.failed' = 'Necesita más práctica'
  public 'interviewer.ai.result' = 'Resultado'
  public 'interviewer.ai.description' = 'El test consiste en {{amount}} preguntas principales con posibles preguntas de seguimiento.\nLa duración aproximada es de {{expectedTime}}.'
  public 'interviewer.ai.description_singular' = 'El test consiste en {{amount}} pregunta con posibles preguntas de seguimiento.\nLa duración aproximada es de {{expectedTime}}.'

  public 'interviewer.ai.dataScience.result.disclaimer' = '<intro><b>Nota:</b> Este test es solo una evaluación de habilidades técnicas. Las entrevistas reales de data science suelen evaluar también:</intro><list><item>Análisis de casos de negocio</item><item>Diseño y arquitectura de sistemas</item><item>Soft skills y encaje cultural</item></list>'
  public 'interviewer.ai.behavioural.resources.title' = 'Recursos'
  public 'interviewer.ai.behavioural.resources.video' = 'Puedes ver este <1>video</1> en el que explicamos cómo preparse una entrevista de FIT.'
  public 'interviewer.ai.behavioural.resources.document' = 'En este <1>documento</1> podrás encontrar una guía de cómo utilizar el método STAR para responder preguntas sobre situaciones pasadas personales.'
  public 'interviewer.ai.behavioural.resources.summary' = 'En esta entrevista se espera que utilices el método STAR para responder las preguntas. Este método ayudar a que tu respuesta sea coherente, lógica y ordenada.'
  public 'interviewer.ai.custom.resources.title' = '¿Cómo funciona?'
  public 'interviewer.ai.custom.resources.summary' = 'Esta herramienta genera entrevistas a medida a partir de la descripción del puesto para que puedas practicar y mejorar tus respuestas.'
  public 'interviewer.ai.loadingMessages.asking.0' = 'Estamos procesando tu respuesta'
  public 'interviewer.ai.loadingMessages.asking.1' = 'Evaluando la respuesta'
  public 'interviewer.ai.loadingMessages.asking.2' = 'Nos llevará un momento'
  public 'interviewer.ai.loadingMessages.asking.3' = 'Decidiendo siguiente acción'
  public 'interviewer.ai.loadingMessages.asking.4' = 'Ya casi estamos'
  public 'interviewer.ai.loadingMessages.default.0' = 'Preparando todo...'
  public 'interviewer.ai.loadingMessages.default.1' = 'Un momento por favor...'
  public 'interviewer.ai.loadingMessages.evaluating.0' = 'Evaluando la entrevista'
  public 'interviewer.ai.loadingMessages.evaluating.1' = 'Procesando todas las respuestas'
  public 'interviewer.ai.loadingMessages.evaluating.2' = 'Evaluando la calidad y profundidad de las respuestas'
  public 'interviewer.ai.loadingMessages.evaluating.3' = 'Seguimos trabajando en ello'
  public 'interviewer.ai.loadingMessages.evaluating.4' = 'Escribiendo el feedback'
  public 'interviewer.ai.loadingMessages.evaluating.5' = 'Decidiendo el resultado'
  public 'interviewer.ai.loadingMessages.evaluating.6' = 'Ya casi estamos'
  public 'interviewer.ai.jobDescription.error.message' = 'Hay un problema con la descripción de la oferta y no podemos generar la entrevista. Por favor, ponte en contacto con nosotros a través de hola@zriveapp.com para solucionarlo.'

  public 'jobs.last' = 'Últimos empleos'
  public 'jobs.title' = 'Empleos'
  public 'jobs.description' = 'Hemos filtrado las mejores ofertas de empleo para perfiles junior en España para que tú no tengas que hacerlo.'
  public 'jobs.workShift' = 'Jornada'
  public 'jobs.internship' = 'Prácticas'
  public 'jobs.invitation.recruiting.event' = 'Invitación a evento'
  public 'jobs.recruiting.event' = 'Evento'
  public 'jobs.unlimited' = 'Indefinido'
  public 'jobs.internship.curriculars' = 'Prácticas curriculares'
  public 'jobs.internship.agreement' = 'Con convenio de prácticas'
  public 'jobs.see.offer' = 'Ver oferta'
  public 'jobs.apply.offer' = 'Acceder a la oferta'
  public 'jobs.apply.offer.now' = 'Solicitar ahora'
  public 'jobs.apply.latest.cv.used' = 'Se utilizará tu último CV.'
  public 'jobs.apply.description' = 'Desde BLOOM estamos colaborando con {{company}} para ayudarles a encontrar el mejor talento joven.\nSi te interesa esta posición, por favor completa este formulario para que podamos considerar tu candidatura'
  public 'jobs.application.sent' = 'Solicitud enviada'
  public 'jobs.apply.success' = 'Tu candidatura ya ha sido enviada a la empresa.'
  public 'jobs.apply.success.description' = 'Si tu perfil les encaja, es posible que te contacten en los próximos días. Mientras tanto, puedes seguir mejorando tu candidatura preparando la entrevista con nuestras herramientas.'
  public 'jobs.apply.profContext.label' = 'Contexto sobre tu situación profesional actual'
  public 'jobs.apply.profContext.placeholder' = 'Escribe tu situación profesional actual y tus objetivos'
  public 'jobs.apply.confirmWorkShift' = 'Confirmo que podré trabajar bajo {{workShiftLabel}}'
  public 'jobs.apply.confirmLocation' = 'Confirmo que podré trabajar en {{countryName}}'
  public 'jobs.apply.canSignInternshipAgreement.label' = '¿Puedes firmar un convenio de prácticas (curricular o extra-curricular)?'
  public 'jobs.prepare.for.interview' = 'Preparar entrevistas'
  public 'jobs.prepare.interview' = 'Preparar entrevista'
  public 'jobs.prepare.interview.fit' = 'Practicar soft-skills (FIT)'
  public 'jobs.prepare.interview.behavioural' = 'Practicar soft-skills (behavioural)'
  public 'jobs.have.applied' = 'Candidatura enviada'
  public 'jobs.have.engaged' = 'Preparando candidatura'
  public 'jobs.see.applied' = 'Mis trabajos'
  public 'jobs.see.internal' = 'Ofertas BLOOM'
  public 'jobs.contract.type' = 'Tipo de contrato'
  public 'jobs.contract.details' = 'Detalles del contrato'
  public 'jobs.apply.date.limit' = 'Fecha límite'
  public 'jobs.contact.person' = 'Persona de contacto'
  public 'jobs.process.train' = 'Prepárate para el proceso'
  public 'jobs.process.info' = 'Conoce su proceso de selección'
  public 'jobs.enableAlerts' = 'Activa tus alertas'
  public 'jobs.dontMissOffers' = 'para no perderte ninguna oferta!'
  public 'jobs.internal' = 'Oferta BLOOM'
  public 'jobs.improve.candidate.title' = 'Mejorar candidatura'
  public 'jobs.improve.candidate.subTitle' = 'Adapta tu perfil'
  public 'jobs.improve.candidate.description' = 'Te ayudamos a mejorar tu perfil para maximizar tus opciones de conseguir el trabajo'
  public 'jobs.improve.candidate.adapt.cv' = 'Adaptar CV'
  public 'jobs.match.level.cv' = 'Compatibilidad de tu CV'
  public 'jobs.info.profile.with.ai' = 'Puedes enviar tu candidatura directamente o adaptar tu perfil a la oferta de trabajo con ayuda de nuestra IA.'

  public 'courses.title' = 'Cursos'
  public 'courses.document' = 'Documento'
  public 'courses.class' = 'Clase'
  public 'courses.supportMaterial' = 'Materiales de soporte'
  public 'courses.completed.video' = '¡Completado!'
  public 'courses.completed.section' = '¡Unidad completada!'
  public 'course.authors.title' = 'Conoce a tus profesores'
  public 'course.start' = 'Comenzar curso'
  public 'course.continue' = 'Continuar curso'
  public 'course.nextPromotion' = 'Próxima promoción'

  public 'studioAi.home.title' = 'Mejora tu perfil como candidato'
  public 'studioAi.home.subtitle' = 'Prepara un CV profesional, practica entrevistas reales y resuelve tus dudas sobre carreras profesionales. Conviértete en un mejor candidato.'
  public 'studioAi.home.cvRoaster' = 'CV Roaster'
  public 'studioAi.home.aiInterview' = 'Interviewer AI'
  public 'studioAi.home.advisorAi' = 'Advisor AI'
  public 'studioAi.home.cvRoaster.subtitle' = 'Optimiza tu CV y asegúrate de que no lo rechazan a la primera'
  public 'studioAi.home.cvRoaster.job.feedback' = 'Feedback adaptado a la oferta'
  public 'studioAi.home.cvRoaster.job.new' = 'Nueva versión'
  public 'studioAi.home.aiInterview.subtitle' = 'Simula entrevistas y mejora con feedback personalizado'
  public 'studioAi.home.aiInterview.job.header' = 'Entrevista adaptada a la oferta'
  public 'studioAi.home.advisorAi.subtitle' = 'Explora todo el conocimiento de BLOOM con nuestra IA'

  public 'interviewer.ai.topic.custom-interview.description' = 'Entrevista adaptada a la oferta de trabajo'
  public 'interviewer.ai.topic.custom-interview.add.job.description' = 'Añade la descripción del puesto aquí...'
  public 'interviewer.ai.job.description.required' = 'Por favor añade la descripción del puesto de trabajo'
  public 'interviewer.ai.topic.behavioural.description' = 'Entrevista de comportamiento sobre situaciones pasadas (método STAR)'
  public 'interviewer.ai.topic.fit-interview.description' = 'Practica cómo hablar sobre ti y sobre tu experiencia'
  public 'interviewer.ai.topic.data-science.description' = 'Entrevista técnica sobre Data Science y Machine Learning'

  public 'premium.banner.description' = 'Acceso ilimitado a las herramientas más avanzadas para mejorar tu perfil y conseguir que destaque entre los demás candidatos.'
  public 'premium.cta.button' = 'Únete ahora'

  public 'zriveReferralProgram.title' = 'Recomienda Zrive a tus amigos'
  public 'zriveReferralProgram.youGet' = 'Tu Obtienes'
  public 'zriveReferralProgram.theyGet' = 'Ellos obtienen'
  public 'zriveReferralProgram.theyGet.description1' = '<0>5% de descuento</0> en el curso de Zrive'
  public 'zriveReferralProgram.description1' = '<0>90 días de Bloom Pro GRATIS</0><br />por cada amigo que se registre en Zrive.'
  public 'zriveReferralProgram.description2' = 'Vale de Amazon de 100€<br />cuando <0>3 amigos</0> se registren en Zrive'
  public 'zriveReferralProgram.friendName' = 'Nombre de tu amigo'
  public 'zriveReferralProgram.friendEmail' = 'Email de tu amigo'
  public 'zriveReferralProgram.program' = 'Programa Zrive'
  public 'zriveReferralProgram.submit' = 'Enviar invitación'
  public 'zriveReferralProgram.success' = '¡Invitación enviada! Tu amigo recibirá un correo.'
  public 'zriveReferralProgram.sendAnother' = 'Enviar otra invitación'
  public 'zriveReferralProgram.validation.required' = 'Email y programa son obligatorios.'
  public 'zriveReferralProgram.referralsCompleted' = 'Amigos que se unieron a Zrive'
  public 'zriveReferralProgram.inviteSectionTitle' = 'Invita a un amigo'
  public 'zriveReferralProgram.myRewards' = 'Mis recompensas'
  public 'zriveReferralProgram.claim' = 'Canjear'
  public 'zriveReferralProgram.claimed' = 'Canjeado'
  public 'zriveReferralProgram.claimSuccessBloom' = 'Has canjeado esta recompensa correctamente'
  public 'zriveReferralProgram.claimSuccessAmazon' = 'Te enviaremos la recompensa a tu correo pronto'
  public 'zriveReferralProgram.noRewardsYet' = 'Aún no tienes recompensas. Aparecerán aquí cuando tengas alguna por canjear o ya canjeada.'
  public 'zriveReferralProgram.referralsNeeded' = 'Falta {{count}} amigo'
  public 'zriveReferralProgram.programNotPartOfReferral' = 'Nos encantará que invites a un amigo, aunque en este caso no hay recompensas asociadas al programa que seleccionaste. Para más información consulta términos y condiciones.'
  public 'zriveReferralProgram.bannerUnclaimedMessage' = 'Tienes recompensas por canjear'
  public 'zriveReferralProgram.bannerUnclaimedLink' = 'Canjear recompensas'

  public 'upgradePro.title' = 'Has superado el límite de usos gratuitos'
  public 'upgradePro.subtitle' = 'Únete a BLOOM PRO para seguir mejorando tu perfil'
  public 'upgradePro.benefitsHeader' = 'Con BLOOM PRO obtendrás:'
  public 'upgradePro.benefit1' = 'Uso ilimitado de todas nuestra herramientas de IA entrenadas para ayudarte a mejorar tu CV, adaptarlo a ofertas de trabajo, y a preparar las entrevistas.'
  public 'upgradePro.benefit2' = 'Recomendaciones BLOOM. Trabajamos con empresas que confían en BLOOM para encontrar el mejor talento. Cuánto más te prepares y más te conozcamos, más te podremos recomendar.'
  public 'upgradePro.cta' = 'Actualizar a PRO'

  public 'speech.to.text.disclaimer' = 'La respuesta con audio es una funcionalidad en BETA. Se recomienda utilizar Google Chrome y asegurarse de que no hay ruido de fondo para maximizar la calidad del audio.'
}
